import React from 'react';
interface PanelCardProps {
  title: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}
export function PanelCard({
  title,
  icon,
  action,
  children,
  className = ''
}: PanelCardProps) {
  return <section className={`flex flex-col rounded-lg border border-slate-200 bg-white shadow-sm ${className}`} data-id="element-41" data-mp="b3hc851eo0mj">
      <header className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-5 py-4" data-id="element-42" data-mp="136zsmn72x8f">
        <div className="flex items-center gap-2.5" data-id="element-43" data-mp="3shcqmqk6bomn">
          {icon ? <span className="text-[#0176d3]" data-id="element-44" data-mp="3sfruwxm4hzn7">{icon}</span> : null}
          <h2 className="text-sm font-semibold text-slate-900" data-id="element-45" data-mp="3ohc9uz9lr1cf">{title}</h2>
        </div>
        {action}
      </header>
      <div className="flex flex-1 flex-col px-5 py-4" data-id="element-46" data-mp="3jir8gwim6bme">{children}</div>
    </section>;
}